import React, { useEffect, useState } from 'react';
import { Layout } from 'tea-component';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';

import '@/pages/opinion/assets/scss/pages/stats/language.scss';
import { connect, useDispatch } from 'umi';
import CardLoading from '@/pages/opinion/components/CardLoading';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import ChartsBox from '../components/ChartsBox';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import StatsLanguagePoint from '@op/operationLog/pages/statsLanguage';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';
import DetailPageTable, { ChannelType } from '@op/components/DetailPageTable';
const { Content } = Layout; 

function Language({ gameInfo, language, languageLoading, wholeGameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: StatsLanguagePoint });
  const {
    loading,
    filter,
    changeFilter,
    filterOptions,
    scrollBody,
    changeTopicList,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Stats_Language',
  });
  const { formatMessage } = useLanguage();
  const dispatch = useDispatch();
  const [channelType, setChannelType] = useState<ChannelType>('social');

  useEffect(() => {
    if (!gameInfo || !filter) return;
    dispatch({
      type: 'opinionPerformance/getOverviewLanguage',
      payload: {
        ...filter,
        ...gameInfo,
        statistics_field: 'language',
        version_time: '1',
      },
    });
  }, [gameInfo, filter]);

  return (
    <Content className="dbo-language dbo-stats" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.LANGUAGE}
        contentHeard={
          <Content.Header title={formatMessage({ id: PAGE_NAME.LANGUAGE })} />
        }
      >
        <FilterFixed
          filter={filterOptions}
          confirm={(value: any) => {
            changeFilter({...value, ...gameInfo});
          }}
          backCondOriginData={(value) => {
            changeTopicList({ topic_trans: value.topic_trans, key_topic: {} });
          }}
          scrollBody={scrollBody}
        ></FilterFixed>
        <CardLoading loading={loading}>
          <ChartsBox
            data={language}
            loading={languageLoading}
            filter={filter}
            dataType="language"
          ></ChartsBox>
          <DetailPageTable
            hasNews={true}
            gameInfo={gameInfo}
            channelType={channelType}
            setChannelType={setChannelType}
            defaultPageInfo={{ page: 1, page_size: 5 }}
            filter={filter}
            hasPageable={false}
            wholeGameInfo={wholeGameInfo}
          ></DetailPageTable>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { loading, opinionCommon, opinionPerformance } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,

    languageLoading: loading.effects['opinionPerformance/getOverviewLanguage'],
    language: opinionPerformance.language,
  };
})(Language);
